import React from 'react';
import { Link } from 'react-router-dom';
import { GmailLogo } from './GmailConnectCard';

export const WELCOME_ALLOWS = [
  'Analyze eligible bills, receipts, and merchant messages',
  'Monitor connected bank transactions for recurring charges, refunds, and credits',
  'Ask for approval before we contact a merchant or take action',
];

export function markWelcomeAccepted() {
  localStorage.setItem('np_welcome_consent', '1');
}

export async function flushWelcomeConsent(grantConsent) {
  if (localStorage.getItem('np_welcome_consent') !== '1') return;
  try {
    await grantConsent('welcome');
    localStorage.removeItem('np_welcome_consent');
  } catch {
    /* User can continue; Settings will show this as off until it saves. */
  }
}

export default function NeverOverpayWelcome({
  googleReady = false,
  googleHref = '',
  onGoogle,
  onEmail,
  showAuthButtons = true,
  continueLabel = 'Continue',
  onContinue,
  busy = false,
}) {
  return (
    <section className="np-card np-welcome" data-testid="neveroverpay-welcome">
      <h1>Welcome to BilledTwice AI</h1>
      <p className="np-welcome-lead">
        Find refunds, stop unwanted renewals, catch billing errors,
        and avoid paying more than you should.
      </p>
      <p className="np-welcome-will">We will:</p>
      <ul className="np-list">
        {WELCOME_ALLOWS.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      {showAuthButtons ? (
        <>
          <div className="np-actions">
            {googleReady && googleHref ? (
              <a
                className="np-btn gmail np-btn-lg np-btn-icon"
                href={googleHref}
                onClick={() => {
                  markWelcomeAccepted();
                  if (onGoogle) onGoogle();
                }}
              >
                <GmailLogo size={18} /> Continue with Google
              </a>
            ) : null}
            <button type="button" className={googleReady ? 'np-btn ghost np-btn-lg' : 'np-btn np-btn-lg'} disabled={busy} onClick={() => {
              markWelcomeAccepted();
              if (onEmail) onEmail();
            }}>
              Continue with Email
            </button>
          </div>
          {!googleReady ? (
            <p className="np-muted np-welcome-note">Google sign-in is not configured on this server yet. Use email, or paste the same Google OAuth client Snagcart uses in Admin.</p>
          ) : null}
          <p className="np-muted np-welcome-legal">
            By continuing, you agree to the <Link to="/terms">Terms</Link> and <Link to="/privacy">Privacy</Link> policy.
            We still ask before we contact a merchant.
          </p>
        </>
      ) : (
        <div className="np-actions">
          <button type="button" className="np-btn np-btn-lg" disabled={busy} onClick={onContinue}>
            {continueLabel}
          </button>
        </div>
      )}
    </section>
  );
}
